import { Link } from "react-router-dom";
import {
  LoginAdditionalContentBase,
  type LoginAdditionalContentBaseProps,
} from "@core/features/auth";
import { Type } from "@themes/pollinator/ui/Type";

export type Props = Omit<
  LoginAdditionalContentBaseProps,
  "renderSignupLink" | "renderForgotPasswordLink"
>;

export function AuthLoginAdditionalContent({ hideSignupLink = false }: Props) {
  return (
    <LoginAdditionalContentBase
      hideSignupLink={hideSignupLink}
      className="flex flex-col items-center gap-4"
      renderSignupLink={() => null}
      renderForgotPasswordLink={() => (
        <Type variant="caption">
          <Link
            to="/forgot-password"
            className="underline hover:text-brand-600 transition-color duration-200"
          >
            Forgot your password?
          </Link>
        </Type>
      )}
    />
  );
}

export default AuthLoginAdditionalContent;

